import type { NextRouter } from 'next/router';
import { type Dispatch, useEffect } from 'react';

import { getLastSearchFlight } from '../../common/lastSearch';
import type { FlightSearchForm } from '../../types';
import actions from '../flightActions';

export const useFlightInitialState = (
    dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>,
    prefill: Partial<FlightSearchForm> | undefined,
    query: NextRouter['query'],
) => {
    useEffect(() => {
        let changedFields: Record<string, string | string[] | undefined | number | boolean | Date | null>;

        // Should only override last search parameters with query params if override=true is in the query
        if (query.override) {
            // biome-ignore lint/correctness/noUnusedVariables: override is unused on purpose
            const { override, ...rest } = query;
            changedFields = rest;
        } else {
            changedFields = { ...getLastSearchFlight(), ...prefill };
        }

        dispatch(actions.allFieldsChanged(changedFields));
    }, []);
};
